import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Aperture, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Input } from "../components/ui/input";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) {
    navigate("/admin", { replace: true });
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0D0F12] px-6 grain relative" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="mb-10 text-center">
          <Aperture className="mx-auto h-8 w-8 text-[#D6705A]" strokeWidth={1.5} />
          <h1 className="mt-6 font-display text-3xl font-light text-[#F9F8F6]">Area riservata</h1>
          <p className="mt-2 font-code text-[10px] uppercase tracking-[0.3em] text-[#666]">L&rsquo;Obiettivo Immobiliare</p>
        </div>

        <form onSubmit={submit} className="space-y-5 border border-white/10 bg-[#16191D] p-8" data-testid="admin-login-form">
          <div>
            <label className="mb-2 block font-code text-[10px] uppercase tracking-[0.25em] text-[#A0A0A0]">Email</label>
            <Input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-[#0D0F12] border-white/10 text-[#F9F8F6] h-12 rounded-none focus-visible:ring-[#D6705A]"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="mb-2 block font-code text-[10px] uppercase tracking-[0.25em] text-[#A0A0A0]">Password</label>
            <Input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-[#0D0F12] border-white/10 text-[#F9F8F6] h-12 rounded-none focus-visible:ring-[#D6705A]"
              data-testid="admin-password-input"
            />
          </div>
          {error && (
            <p className="border border-red-900/50 bg-red-950/30 px-4 py-3 text-xs text-red-300" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit" disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#D6705A] py-4 font-code text-[11px] uppercase tracking-[0.25em] text-[#0D0F12] transition-colors duration-300 hover:bg-[#F9F8F6] disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Accedi
          </button>
        </form>

        <Link to="/" className="mt-8 block text-center font-code text-[10px] uppercase tracking-[0.25em] text-[#666] transition-colors hover:text-[#A0A0A0]" data-testid="admin-back-home">
          ← Torna al sito
        </Link>
      </div>
    </div>
  );
}
